import { ACCEPTED_IMAGE_TYPES } from '../../model/consts';

export const getFilesValidationError = (files: File[], t: (key: string) => string) => {
    const maxFiles = 10;
    const maxFileSize = 5242880;

    if (files.length > maxFiles) {
        return `${t('imagePlaceholder.onInputChange.errors.amount_limit_first')} 10 ${t(
            'imagePlaceholder.onInputChange.errors.amount_limit_second'
        )}`;
    }

    if (files.some((file) => file.size >= maxFileSize)) {
        return `${t('imagePlaceholder.onInputChange.errors.size_limit_first')} 5 ${t(
            'imagePlaceholder.onInputChange.errors.size_limit_second'
        )}`;
    }

    if (files.some((file) => !ACCEPTED_IMAGE_TYPES.includes(file.type))) {
        return `${t('imagePlaceholder.onInputChange.errors.invalid_format')} (jpeg, jpg, png, gif)`;
    }

    return '';
};
